import { render, staticRenderFns } from "./GroupProgram.vue?vue&type=template&id=91233200"
import script from "./GroupProgram.vue?vue&type=script&lang=js"
export * from "./GroupProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports